import { reactive } from 'vue'

export const state = reactive({
  currentStage: null,
  isListening: false,
  isHelpStage: false,
  isPopupOpened: true
})

export const toggleListening = (value) => {
  state.isListening = value
}

export const togglePopupState = (value) => {
  state.isPopupOpened = value
}

export const toggleHelpStage = (value) => {
  state.isHelpStage = value
}

export const updateCurrentStage = (value) => {
  state.currentStage = value
}
